import React from 'react';
import { StoryWrapper } from '../StoryWrapper';
import styles from '../week-reflection.module.css';
import FireImg from "../../../images/fire.svg";
import ConsistencyRewardImg from "../../../images/rewards/ConsistencyReward.svg";

export const DayStreak = ({ story, action, isPaused, config, storyData }) => {
    return (
        <StoryWrapper storyName={storyData.component} action={action} isPaused={isPaused}>
            <h1
                className={styles.size2}
                style={{ marginBottom: storyData.data.isActiveHighlighted ? "2rem" : "1.5rem", maxWidth: "18rem" }}
            >
                {storyData.data.heading} <b>{storyData.data.numDaysInStreak}</b> {storyData.data.isActiveHighlighted ? 'days!' : 'days'}
            </h1>
            <div
                className={styles.flexWrapContainer}
                style={{ maxWidth: storyData.data.supportingImage.count <= 5 ? "18rem" : "14rem" }}
            >
                {Array.from({ length: storyData.data.supportingImage.count }).map((_, index) => (
                    <img className={styles.streakImage}
                        key={index}
                        src={storyData.data.supportingImage.name === 'Fire' ? FireImg : ConsistencyRewardImg}
                        alt={`${storyData.data.supportingImage.name} image`}
                        height="45px"
                    />
                ))}
            </div>
            {storyData.data.subheading &&
                <p
                    className={styles.streakSubheading}
                    style={{ marginTop: storyData.data.isActiveHighlighted ? "2.5rem" : "1.5rem" }}
                >
                    {storyData.data.subheading}
                </p>
            }
        </StoryWrapper>
    )
}